import { createFileRoute } from "@tanstack/react-router";
import { DepreciationRulesTab } from "@/features/finance/DepreciationRulesTab";
import { useCurrentUser } from "@/hooks/useCurrentUser";
import { canRunDepreciation } from "@/lib/permissions";
import { ReadOnlyPill } from "@/components/auth/ReadOnlyPill";

export const Route = createFileRoute("/_authenticated/finance/depreciation-rules")({
  component: DepreciationRulesPage,
});

function DepreciationRulesPage() {
  const { data: me } = useCurrentUser();
  const readOnly = !canRunDepreciation(me?.roles ?? []);
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">
          Depreciation Rules <ReadOnlyPill module="finance" />
        </h1>
        <p className="text-sm text-muted-foreground">
          Master rules that determine how each asset depreciates. Assets inherit the most specific matching rule at creation.
        </p>
      </div>
      <DepreciationRulesTab readOnly={readOnly} />
    </div>
  );
}
